import { footer, mainNav, type SiteDef  } from '@luxfi/ui/site-def'

export default {
  currentAs: 'https://lux.quest',
  nav: {
    common: mainNav,
  },
  footer: footer.standard
} satisfies SiteDef


